import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { firstValueFrom, Observable, of } from 'rxjs';
import { LanguageService } from '../../../core/services/language/language.service';
import { isNotNullOrUndefined } from '../../../core/utils/typeUtils';
import { FrontendLanguage, SUPPORTED_LANGS } from '../../../core/utils/languageUtils';

const langFromQueryParamGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const languageService: LanguageService = inject(LanguageService);
  const lang = (route.queryParamMap.get('lang')?.toLowerCase() as FrontendLanguage) || undefined;

  if (SUPPORTED_LANGS.includes(lang) && isNotNullOrUndefined(lang)) {
    firstValueFrom(languageService.setLanguage$(lang));
  }

  return of(true);
};

export { langFromQueryParamGuard };
